import * as Yup from 'yup';
import { useState, useContext } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
// material
import { Stack, TextField, IconButton, InputAdornment, Alert } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

// component
import Theme from '../../../components/Button';
import Iconify from '../../../components/Iconify';

import { registrar } from '../../../services/api';  

// ----------------------------------------------------------------------

export default function RegisterForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const RegisterSchema = Yup.object().shape({
    usuario: Yup.string().min(2, 'Muito Pequeno!').max(50, 'Muito Longo!').required('Usuário é obrigatório'),
    email: Yup.string().email('Informe um email válido').required('Email é obrigatório'),
    senha: Yup.string().required('Senha é obrigatório'),
    confirmacaoSenha: Yup.string().required('Confirmação de Senha é obrigatório'),
  });

  const formik = useFormik({
    initialValues: {
      usuario: '',
      email: '',
      senha: '',
      confirmacaoSenha: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const retorno = await registrar(formik.values.usuario, formik.values.email, formik.values.senha, formik.values.confirmacaoSenha);
    
    if (retorno) {
       if(retorno.erro === true) {
           setStatus({
             type: 'erro',
             mensagem: retorno.mensagem
           })
       }else{
          setStatus({
            type: 'success',
            mensagem: retorno.data.mensagem
          })
       } 
    }

  } 

  const { errors, touched, isSubmitting, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            label="Usuário"
            {...getFieldProps('usuario')}
            error={Boolean(touched.usuario && errors.usuario)}
            helperText={touched.usuario && errors.usuario}
          />

          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label="Email"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Senha"
            {...getFieldProps('senha')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={Boolean(touched.senha && errors.senha)}
            helperText={touched.senha && errors.senha}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Confirme Senha"
            {...getFieldProps('confirmacaoSenha')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={Boolean(touched.confirmacaoSenha && errors.confirmacaoSenha)}
            helperText={touched.confirmacaoSenha && errors.confirmacaoSenha}
          />

          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>     

          <ThemeProvider theme={Theme}>  
            <LoadingButton color="neutral" fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
              Cadastrar
            </LoadingButton>
          </ThemeProvider>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
